'use strict'

const listStyle = {}

listStyle[listStyle['none'] = 0] = 'none'
listStyle[listStyle['inline'] = 1] = 'inline'
listStyle[listStyle['list'] = 2] = 'list'
listStyle[listStyle['button'] = 3] = 'button'
listStyle[listStyle['auto'] = 4] = 'auto'

export default listStyle
